export class WorkshopConfig {
  prefixWorkshop: string = 'WS-{year}-';
  workshopHeader: string = '';
  workshopFooter: string = '';
  additionalIntakeText: string = '';
  additionalCheckoutText: string = '';
  // Regulated product type proposed in front of the product search at intake (null: plain products)
  defaultComplianceProductTypeId: number | null = null;
}
